import { createContext, useContext, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { api } from '../../lib/api';

const AdminAuthContext = createContext(null);
export const useAdminAuth = () => useContext(AdminAuthContext);

export const AdminGate = ({ children }) => {
  const [auth, setAuth] = useState({ state: 'checking', email: null });

  useEffect(() => {
    let cancelled = false;
    api
      .get('/admin/me')
      .then((r) => {
        if (!cancelled) setAuth({ state: 'authenticated', email: r.data.email });
      })
      .catch(() => {
        if (!cancelled) setAuth({ state: 'unauthenticated', email: null });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (auth.state === 'checking') {
    return (
      <main
        className="flex min-h-screen items-center justify-center bg-brand-iceSoft"
        data-testid="admin-auth-loading"
        role="status"
        aria-label="Checking authentication"
      >
        <Loader2 className="h-8 w-8 animate-spin text-brand-skyDeep" aria-hidden="true" />
      </main>
    );
  }

  if (auth.state === 'unauthenticated') {
    return <Navigate to="/admin/login" replace />;
  }

  return <AdminAuthContext.Provider value={auth}>{children}</AdminAuthContext.Provider>;
};
